/**
 * Returns a number indicating whether a reference string comes before or after
 * or is the same as the given string in numeric collation sort order.
 *
 * @param {string} referenceString The string which is compared.
 * @param {string} compareString The string against which the referring string is compared.
 * @return A negative number if the reference string occurs before the compare string;
 * positive if the reference string occurs after the compare string; 0 if they are equivalent.
 */
export function strCompare (referenceString, compareString) {
  return String(referenceString)
    .localeCompare(compareString, undefined, { numeric: true })
}

export function capitalize (string) {
  const headCharacter = String(string).slice(0, 1)
  const tailCharacters = String(string).slice(1)

  return headCharacter.toLocaleUpperCase() + tailCharacters
}



// WEBPACK FOOTER //
// ./src/server/helpers/string.js